import React from "react";
import {
  PanelBody,
  PanelRow,
  BaseControl,
  TextControl,
  Button,
  ExternalLink,
} from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import { useState, useEffect } from "@wordpress/element";

import useSettings from "../utils/useSettings";
const integrations = () => {
  const [getOption, updateOption, status] = useSettings();
  const [googleMapsAPI, setGoogleMapsAPI] = useState("");
  const [mailchimpAPI, setMailchimpAPI] = useState("");

  useEffect(() => {
    setGoogleMapsAPI(getOption("ultrablocks_google_maps_api_key"));
  }, [getOption("ultrablocks_google_maps_api_key")]);

  return (
    <>
      <PanelBody title={__("Google Maps", "ultrablocks")}>
        <PanelRow>
          <BaseControl
            label={__("Google Maps API", "ultrablocks")}
            help={__(
              "In order to use Google Maps block, you need to use Google Maps and Places API.",
              "ultrablocks"
            )}
            id="ultrablocks-options-google-map-api"
            className="ultrablocks-button-field"
          >
            <TextControl
              type="text"
              label={__("Secret Key", "ultrablocks")}
              value={googleMapsAPI}
              placeholder={__("Google Maps API Key", "ultrablocks")}
              disabled={"saving" === status}
              onChange={(value) => setGoogleMapsAPI(value)}
            />

            <div className="ultrablocks-button-group">
              <Button
                variant="secondary"
                className="ubs-action-button"
                isSecondary
                disabled={"saving" === status}
                onClick={() =>
                  updateOption("ultrablocks_google_maps_api_key", googleMapsAPI)
                }
              >
                {__("Save", "ultrablocks")}
              </Button>

              <ExternalLink href="https://developers.google.com/maps/documentation/javascript/get-api-key">
                {__("Get API Key", "ultrablocks")}
              </ExternalLink>
            </div>
          </BaseControl>
        </PanelRow>
      </PanelBody>
      <PanelBody title={__("Mailchimp   (Coming Soon...)", "ultrablocks")}>
        <PanelRow>
          <BaseControl
            label={__("Mailchimp API", "ultrablocks")}
            help={__(
              "In order to use Mailchimp block, you need to use Mailchimp API.",
              "ultrablocks"
            )}
            id="ultrablocks-options-mailchimp-api"
            className="ultrablocks-button-field"
          >
            <TextControl
              type="text"
              label={__("Secret Key", "ultrablocks")}
              value={mailchimpAPI}
              placeholder={__("Mailchimp API Key", "ultrablocks")}
              disabled={true}
              onChange={(value) => setMailchimpAPI(value)}
            />

            <div className="ultrablocks-button-group">
              <Button
                variant="secondary"
                className="ubs-action-button"
                isSecondary
                disabled={true}
                onClick={() =>
                  updateOption("ultrablocks_mailchimp_api_key", mailchimpAPI)
                }
              >
                {__("Save", "ultrablocks")}
              </Button>

              <ExternalLink href="https://mailchimp.com/">
                {__("Get API Key", "ultrablocks")}
              </ExternalLink>
            </div>
          </BaseControl>
        </PanelRow>
      </PanelBody>
    </>
  );
};

export default integrations;
